import { render, staticRenderFns } from "./Plantas.vue?vue&type=template&id=4718e1c8"
import script from "./Plantas.vue?vue&type=script&lang=js"
export * from "./Plantas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports